import React, { Component } from 'react';
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import globalVariables from "../../custom_libraries/globalVariables";
import urls from "../../custom_libraries/urls";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2f3541",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

export class TenantAndSecretKeyInfo extends Component {
    constructor(props){
        super(props);
        this.state = {
            tenant_id: '',
            secret_key: '',
            user_id: localStorage.getItem('user_id') || '',
            responseMessage: '',
            success: false,
            error: false,
            isReadOnly: false,
        }
    }

    componentDidMount() {
        const user_id = localStorage.getItem('user_id');
        if (user_id) {
            this.fetchTenantSecret(user_id);
        }
        else {
            console.error('User ID not found in localStorage');
        }
    }

    fetchTenantSecret = (user_id) => {
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        return fetch(urls.GET_TENANT_SECRET(user_id), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
        })
            .then(response => response.json())
            .then(data => {
                console.log('fetching tenant and secret key:', data);
                this.setState({
                    tenant_id: data.data.tenant_id || '',
                    secret_key: data.data.secret_key || '',
                    isReadOnly: !!(data.data.tenant_id && data.data.secret_key),
                });
            }).catch(error => {
                console.error('Error fetching tenant and secret key:', error);
                this.setState({
                    tenant_id: '',
                    secret_key: '',
                });
            });
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { tenant_id, secret_key, user_id } = this.state;
        const payload = {
            tenant_id,
            secret_key,
            user_id,
        };
        fetch(urls.TENANT_SECRET, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                responseMessage: 'Successfully saved the details!',
                success: true,
                error: false,
                });
            console.log('Success:', data);
            return this.fetchTenantSecret(user_id);
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({
                responseMessage: 'Error saving Tenant ID and Secret Key.',
                success: false,
                error: true
            });
        });
    }

  render() {
    const { tenant_id, secret_key, success, error, isReadOnly } = this.state;
    const maskedSecret =
    secret_key.length > 4
        ? secret_key.substring(0, 4) + "*".repeat(secret_key.length - 4)
        : secret_key;
    // const isReadOnly = tenant_id !== '' && secret_key !== '';
    return (
        <ThemeProvider theme={darkTheme}> 
        <CssBaseline />
        <Box
            component="main"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px',
                overflowY: 'auto',
                gap: '20px',
                width: '90%',
                boxSizing: 'border-box',
                '@media (max-width: 768px)': {
                    width: '100%',
                    padding: { xs: '12px', sm: '16px' },
                    gap: 0,
                    overflowX: 'hidden',
                },
            }}
        >
        <Box
            className="health-setting-container"
            sx={{
                minWidth: 0,
                '@media (max-width: 768px)': {
                    width: '100%',
                    margin: 0,
                    padding: { xs: '16px', sm: '20px' },
                    boxSizing: 'border-box',
                },
            }}
        >
            {success && (
                <Alert
                    severity="success"
                    icon={<CheckIcon />}
                    sx={{ maxWidth: '100%', boxSizing: 'border-box', overflowWrap: 'anywhere' }}
                >
                    {this.state.responseMessage}
                </Alert>
            )}
            {error && (
                <Alert
                    severity="error"
                    sx={{ maxWidth: '100%', boxSizing: 'border-box', overflowWrap: 'anywhere' }}
                >
                    {this.state.responseMessage}
                </Alert>
            )}
        <Box
            component="h3"
            sx={{
                marginBottom: '20px',
                '@media (max-width: 768px)': {
                    fontSize: '1.05rem',
                    lineHeight: 1.4,
                },
            }}
        >
            Tenant-ID And Secret Key Info
        </Box>
        <Box
            className="form-section"
            sx={{
                minWidth: 0,
                boxSizing: 'border-box',
                '& input': {
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                },
                '@media (max-width: 768px)': {
                    '& label': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                    },
                },
            }}
        >
            {/* <form onSubmit={this.handleSubmit} style={{marginTop: "25px", display: "flex", flexDirection: "column", alignItems: "flex-start"}}> */}
                <div style={{width:'100%' }}>
                    <label>
                    Tenant ID: &nbsp;
                    <input
                        type="text"
                        className="sms-input"
                        name="tenant_id"
                        value={tenant_id}
                        onChange={this.handleChange}
                        readOnly={isReadOnly}
                    />
                    </label>
                {/* </div><br/> */}
                {/* <div style={{ display: 'flex', alignItems: 'center', gap: '5px', width:'100%' }}> */}
                    <label>
                    Secret Key: &nbsp;
                    <input
                        type="text"
                        className="sms-input"
                        name="secret_key"
                        value={isReadOnly ? maskedSecret : secret_key}
                        onChange={this.handleChange}
                        readOnly={isReadOnly}
                    />
                    </label>
                </div><br/>
{!isReadOnly && (
                <button 
                    // type="submit" 
                    onClick={this.handleSubmit}
                    id="rowsPerPageButton"
                    style={{
                        width: "50px",
                        height: "31px",
                        cursor: isReadOnly ? "not-allowed" : "pointer",
                    }}
                >
                    Save
                </button>
)}
            {/* </form> */}
        </Box>
        </Box>
        </Box>
        </ThemeProvider>
    )
  }
}

export default TenantAndSecretKeyInfo
